<div class="col-12 col-lg-6">
    <div class="pricing-box updated-card {{card_type}}">
        <span class="color"></span>
        <div class="header">
            <h3 class="mb-16">{{card_type_title}}</h3>
            <p class="light mb-8 plan-description">{{plan_description}}</p>
        </div>
        <div class="content">
            <div class="feature-list">
                {{#each items}}
                    <div class="item {{#if included}}{{else}}excluded-item{{/if}}">
                    {{#if included}}
                        <img src="/assets/img/icons/blue_pricing_tick.svg" alt="Check">
                    {{else}}
                        <img src="/assets/img/icons/grey_cross.svg" alt="Cross">
                    {{/if}}
                        <p>{{content}}</p>
                    {{#if beta_badge}}
                        <span class="badge beta">BETA</span>
                    {{/if}}
                    {{#if new_badge}}
                        <span class="badge beta">NEW</span>
                    {{/if}}
                    </div>
                {{/each}}
            </div>
            <div class="pricing-box-button-container mt-24">
                <a class="btn btn-primary ga-track pricing-plan-btn" href="{{plan_link}}" data-gaevent="{{plan_cta}} {{card_type_capital}} Click" data-pricing-plan="{{card_type_capital}} Plan">{{plan_cta}}</a>
            </div>
        </div>
    </div>
</div>